<template>
    <DCard
        :title="__(`settings.tenant_settings.form.fields.finance_systems.payex360`)"
        padding
        class="mb-5"
    >
        <DForm @submit.prevent="submitForm">
            <DFormRow
                :label="__('settings.payex360.form.api_url')"
                :is-required="true"
                :error="errorsData.api_url"
                :hint="__('settings.payex360.form.api_url_hint')"
            >
                <DInput
                    id="payex-url"
                    v-model="payExForm.api_url"
                    :placeholder="__('settings.payex360.form.api_url')"
                    :is-valid="isFormFieldValid('api_url')"
                    maxlength="128"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.payex360.form.api_token')"
                :is-required="payex360SystemSettings === null"
                :error="errorsData.api_token"
                :hint="__('settings.payex360.form.api_token_hint')"
            >
                <DInput
                    id="payex-api_token"
                    v-model="payExForm.api_token"
                    :placeholder="__('settings.payex360.form.api_token')"
                    type="password"
                    :is-valid="isFormFieldValid('api_token')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.payex360.form.certificate_password')"
                :is-required="payex360SystemSettings === null"
                :error="errorsData.certificate_password"
                :hint="__('settings.payex360.form.certificate_password_hint')"
            >
                <DInput
                    id="payex-certificate_password"
                    v-model="payExForm.certificate_password"
                    :placeholder="__('settings.payex360.form.certificate_password')"
                    type="password"
                    :is-valid="isFormFieldValid('certificate_password')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.payex360.form.certificate_pem_file')"
                :is-required="payex360SystemSettings === null"
                :error="errorsData.certificate_pem_file"
                :hint="__('settings.payex360.form.certificate_pem_file_hint')"
            >
                <DFileInput
                    id="payex-certificate_pem_file"
                    :custom="true"
                    :multiple="false"
                    @change="addFile"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.payex360.form.ledger_id')"
                :is-required="true"
                :error="errorsData.ledger_id"
                :hint="__('settings.payex360.form.ledger_id_hint')"
            >
                <DInput
                    id="payex-url"
                    v-model="payExForm.ledger_id"
                    :placeholder="__('settings.payex360.form.ledger_id')"
                    :is-valid="isFormFieldValid('ledger_id')"
                    maxlength="128"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.payex360.form.ledger_name')"
                :is-required="true"
                :error="errorsData.ledger_name"
                :hint="__('settings.payex360.form.ledger_name_hint')"
            >
                <DInput
                    id="payex-url"
                    v-model="payExForm.ledger_name"
                    :placeholder="__('settings.payex360.form.ledger_name')"
                    :is-valid="isFormFieldValid('ledger_name')"
                    maxlength="255"
                />
            </DFormRow>
            <DRow>
                <DCol sm="4" />
                <DCol sm="4">
                    <div
                        v-if="connectionStatusPayex360 === 'successful'"
                        class="connection-successful"
                    >
                        {{ __('settings.payex360.connection_successful') }}
                    </div>
                    <div
                        v-if="connectionStatusPayex360 === 'unsuccessful'"
                        class="connection-failed"
                    >
                        {{ __('settings.payex360.connection_unsuccessful') }}
                    </div>
                </DCol>
                <DCol
                    sm="4"
                    class="check-database-connection-btn"
                >
                    <DButton
                        icon="lan-connect"
                        :label="__('settings.payex360.check_connection')"
                        :disabled="isInLoadingState"
                        @click="checkPayex360Connection"
                    />
                </DCol>
            </DRow>
        </DForm>
        <DForm @submit.prevent="submitForm">
            <DFormRow
                :label="__('settings.payex360.form.ftp_hostname')"
                :is-required="true"
                :error="errorsData.ftp_hostname"
                :hint="__('settings.payex360.form.ftp_hostname_hint')"
            >
                <DInput
                    id="payex-ftp_hostname"
                    v-model="payExForm.ftp_hostname"
                    :placeholder="__('settings.payex360.form.ftp_hostname')"
                    :is-valid="isFormFieldValid('ftp_hostname')"
                    maxlength="128"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.payex360.form.ftp_username')"
                :is-required="true"
                :error="errorsData.ftp_username"
                :hint="__('settings.payex360.form.ftp_username_hint')"
            >
                <DInput
                    id="payex-ftp_username"
                    v-model="payExForm.ftp_username"
                    :placeholder="__('settings.payex360.form.ftp_username')"
                    :is-valid="isFormFieldValid('ftp_username')"
                    maxlength="255"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.payex360.form.ftp_password')"
                :is-required="payex360SystemSettings === null"
                :error="errorsData.ftp_password"
                :hint="__('settings.payex360.form.ftp_password_hint')"
            >
                <DInput
                    id="payex-ftp_password"
                    v-model="payExForm.ftp_password"
                    :placeholder="__('settings.payex360.form.ftp_password')"
                    type="password"
                    :is-valid="isFormFieldValid('ftp_password')"
                    maxlength="255"
                />
            </DFormRow>
            <DRow>
                <DCol sm="4" />
                <DCol sm="4">
                    <div
                        v-if="connectionStatusPayex360Sftp === 'successful'"
                        class="connection-successful"
                    >
                        {{ __('settings.payex360.connection_successful') }}
                    </div>
                    <div
                        v-if="connectionStatusPayex360Sftp === 'unsuccessful'"
                        class="connection-failed"
                    >
                        {{ __('settings.payex360.connection_unsuccessful') }}
                    </div>
                </DCol>
                <DCol
                    sm="4"
                    class="check-database-connection-btn"
                >
                    <DButton
                        icon="lan-connect"
                        :label="__('settings.payex360.check_sftp_connection')"
                        :disabled="isInLoadingState"
                        @click="checkPayex360SftpConnection"
                    />
                </DCol>
            </DRow>
        </DForm>
    </DCard>

    <DCard
        :title="__(`settings.sftp_server.title`)"
        padding
        class="mb-5"
    >
        <DForm @submit.prevent="submitForm">
            <DFormRow
                :label="__('settings.sftp_server.form.hostname')"
                :is-required="true"
                :error="errorsData.hostname"
                :hint="__('settings.sftp_server.form.hostname_hint')"
            >
                <DInput
                    id="visma-url"
                    v-model="payExForm.hostname"
                    :placeholder="__('settings.sftp_server.form.hostname')"
                    :is-valid="isFormFieldValid('hostname')"
                    maxlength="128"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sftp_server.form.username')"
                :is-required="true"
                :error="errorsData.username"
                :hint="__('settings.sftp_server.form.username_hint')"
            >
                <DInput
                    id="visma-username"
                    v-model="payExForm.username"
                    :placeholder="__('settings.sftp_server.form.username')"
                    :is-valid="isFormFieldValid('username')"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sftp_server.form.password')"
                :is-required="vismaBusinessSystemSettings === null"
                :error="errorsData.password"
                :hint="__('settings.sftp_server.form.password_hint')"
            >
                <DInput
                    id="visma-password"
                    v-model="payExForm.password"
                    :placeholder="__('settings.sftp_server.form.password')"
                    type="password"
                    :is-valid="isFormFieldValid('password')"
                    maxlength="255"
                />
            </DFormRow>
            <DRow>
                <DCol sm="4" />
                <DCol sm="4">
                    <div
                        v-if="connectionVismaBusinessSftp === 'successful'"
                        class="connection-successful"
                    >
                        {{ __('settings.sftp_server.connection_successful') }}
                    </div>
                    <div
                        v-if="connectionVismaBusinessSftp === 'unsuccessful'"
                        class="connection-failed"
                    >
                        {{ __('settings.sftp_server.connection_unsuccessful') }}
                    </div>
                </DCol>
                <DCol
                    sm="4"
                    class="check-database-connection-btn"
                >
                    <DButton
                        icon="lan-connect"
                        :label="__('settings.sftp_server.check_connection')"
                        :disabled="isInLoadingState"
                        @click="checkConnection"
                    />
                </DCol>
            </DRow>
            <DFormControls
                v-if="connectionStatusPayex360 === 'successful' && connectionStatusPayex360Sftp === 'successful' && connectionVismaBusinessSftp === 'successful'"
                :dirty="payExForm.isDirty"
                @submit="submitForm"
            />
        </DForm>
    </DCard>
    <DConnectionErrorModal
        :show-modal="connectionException !== null"
        :exception="connectionException"
        @close-modal="closeErrorCheckModal"
    />
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { ref, watch } from 'vue'

import { route } from '~@/Composables/route'
import { toConnectionException, toFlatValidationErrors } from '~@/Composables/connectionException'
import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal.vue'

const props = defineProps({
    payex360SystemSettings: {
        type: Object,
        default: () => { return null }
    },
    vismaBusinessSystemSettings: {
        type: Object,
        default: () => { return null }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const emit = defineEmits(['form-submitted'])

const payExForm = useForm({
    api_url: props.payex360SystemSettings?.api_url ?? '',
    api_token: null,
    certificate_pem_file: null,
    certificate_password: null,
    ftp_hostname: props.payex360SystemSettings?.ftp_hostname ?? '',
    ftp_username: props.payex360SystemSettings?.ftp_username ?? '',
    ftp_password: null,
    ledger_id: props.payex360SystemSettings?.ledger_id ?? '',
    ledger_name: props.payex360SystemSettings?.ledger_name ?? '',
    hostname: props.vismaBusinessSystemSettings?.hostname ?? '',
    username: props.vismaBusinessSystemSettings?.username ?? '',
    password: props.vismaBusinessSystemSettings?.password ?? '',
    finance_system: 'payex360'
})

const connectionStatusPayex360 = ref('')
const connectionStatusPayex360Sftp = ref('')
const connectionVismaBusinessSftp = ref('')
const connectionException = ref(null)
const credentialsAreValid = ref(false)
const credentialsPayex365SftpAreValid = ref(false)
const showErrorCheckModal = ref(false)
const errorsData = ref(props.errors)

watch(() => props.errors, (newErrors, oldErrors) => {
    errorsData.value = newErrors
})

function checkPayex360Connection () {
    errorsData.value = {}
    connectionException.value = null
    credentialsAreValid.value = false

    const formData = new FormData()
    formData.append('api_url', payExForm.api_url ?? '')
    formData.append('certificate_password', payExForm.certificate_password ?? '')
    formData.append('api_token', payExForm.api_token ?? '')
    formData.append('certificate_pem_file', payExForm.certificate_pem_file ?? '')
    formData.append('ledger_id', payExForm.ledger_id ?? '')
    formData.append('ledger_name', payExForm.ledger_name ?? '')

    window.axios.post(route('settings.finance-system-settings.check-payex360'),
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
        .then(function () {
            connectionStatusPayex360.value = 'successful'
            credentialsAreValid.value = true
        })
        .catch(function (error) {
            connectionStatusPayex360.value = 'unsuccessful'
            credentialsAreValid.value = false
            showErrorCheckModal.value = true

            errorsData.value = toFlatValidationErrors(error.response?.data)
            connectionException.value = toConnectionException(error.response?.data)
        })
}

function checkPayex360SftpConnection () {
    errorsData.value = {}
    connectionException.value = null
    credentialsPayex365SftpAreValid.value = false

    const formData = new FormData()
    formData.append('ftp_hostname', payExForm.ftp_hostname ?? '')
    formData.append('ftp_username', payExForm.ftp_username ?? '')
    formData.append('ftp_password', payExForm.ftp_password ?? '')

    window.axios.post(route('settings.finance-system-settings.check-payex360-sftp'),
        formData
    )
        .then(function () {
            connectionStatusPayex360Sftp.value = 'successful'
            credentialsPayex365SftpAreValid.value = true
        })
        .catch(function (error) {
            connectionStatusPayex360Sftp.value = 'unsuccessful'
            credentialsPayex365SftpAreValid.value = false

            errorsData.value = toFlatValidationErrors(error.response?.data)
            connectionException.value = toConnectionException(error.response?.data)
            showErrorCheckModal.value = connectionException.value !== null
        })
}
function checkConnection () {
    errorsData.value = {}
    connectionException.value = null

    const formData = new FormData()
    formData.append('hostname', payExForm.hostname ?? '')
    formData.append('username', payExForm.username ?? '')
    formData.append('password', payExForm.password ?? '')

    window.axios.post(route('settings.finance-system-settings.check-visma-business-sftp'),
        formData
    )
        .then(function () {
            connectionVismaBusinessSftp.value = 'successful'
        })
        .catch(function (error) {
            connectionVismaBusinessSftp.value = 'unsuccessful'

            errorsData.value = toFlatValidationErrors(error.response?.data)
            connectionException.value = toConnectionException(error.response?.data)
            showErrorCheckModal.value = connectionException.value !== null
        })
}

function closeErrorCheckModal () {
    showErrorCheckModal.value = false
    connectionException.value = null
}

function submitForm () {
    emit('form-submitted', payExForm)

    connectionVismaBusinessSftp.value = ''
    connectionStatusPayex360.value = ''
    connectionStatusPayex360Sftp.value = ''
}

function addFile (fileList) {
    payExForm.certificate_pem_file = fileList[0]
}
</script>

<style lang="scss" scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}
.connection-successful {
    color: green;
}
.connection-failed {
    color: red;
}
</style>
